import React, { Component } from 'react'
import { TurnPage } from '@/lib/turneffect'
import { MagazineLoader } from '@/components/commons/LoaderComponent'
import { MagazinesResource } from '@/resources'

export const withTurnPagePlugin = WrapperdComponent => {
  return class extends Component {
    constructor ( props ) {
      super( props )

      this.state = {
        $: null,
        loading: true,
        pages: []
      }

      this.loadingPages = this.loadingPages.bind( this )
    }

    componentWillMount () {
      if ( window.$ ) {
        new TurnPage( window.$ )
        this.setState(
          {
            $: window.$
          },
          () => this.loadingPages()
        )
        return
      }
      import( 'jquery' ).then( $ => {
        new TurnPage( $ )
        this.setState(
          {
            $: $
          },
          () => this.loadingPages()
        )
      } )
    }

    async loadingPages () {
      const isStandAlone =
        this.props.location.search.indexOf( 'standalone=true' ) !== -1
      const { magazineId } = this.props.match.params
      try {
        let items
        if ( !isStandAlone ) {
          items = await MagazinesResource.getPages( magazineId )
        } else {
          items = await MagazinesResource.getPagesForPreview( magazineId )
        }
        return this.setState( {
          pages: items.data,
          loading: false
        } )
      } catch ( err ) {
        console.log( err )
      }
    }

    render () {
      const { loading } = this.state
      const newProps = {
        ...this.state,
        ...this.props
      }
      return loading ? <MagazineLoader /> : <WrapperdComponent {...newProps} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/hocs/withTurnPagePlugin.js